export type DateSelectorType = 'fixedDates' | 'flexibleDates';
